import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(platform)/not-found.tsx");
